import { useTranslation } from "react-i18next";
import {
  RADAR_ATTRIBUTION_URL,
  WIND_ATTRIBUTION_URL,
  WIND_LICENCE_URL,
} from "@divespots/contracts";

interface Props {
  /** A measured radar step is shown: MeteoSwiss (radar), reprojected. */
  atRadar: boolean;
  /** Wind is drawn at this step, so its credit joins the radar's. */
  windShown: boolean;
}

/**
 * The required weather credit, short form with its links: model forecast "Modell · MeteoSwiss via
 * Open-Meteo · CC BY 4.0 · interpoliert", or the radar variants. It sits in the time bar (tablets and
 * desktop) or in the map footer (phones); it is never cut off, it wraps.
 */
export function WeatherCredit({ atRadar, windShown }: Props) {
  const { t } = useTranslation();
  const meteo = (
    <a href={RADAR_ATTRIBUTION_URL} target="_blank" rel="noopener noreferrer">
      MeteoSwiss
    </a>
  );
  const openMeteo = (
    <a href={WIND_ATTRIBUTION_URL} target="_blank" rel="noopener noreferrer">
      Open-Meteo
    </a>
  );
  const licence = (
    <a href={WIND_LICENCE_URL} target="_blank" rel="noopener noreferrer">
      CC BY 4.0
    </a>
  );
  if (atRadar && !windShown)
    return (
      <>
        {meteo} · {licence} · {t("radar.reprojected")}
      </>
    );
  if (atRadar)
    return (
      <>
        {meteo} · {openMeteo} · {licence} · {t("wind.interpolated")}
      </>
    );
  return (
    <>
      {t("weather.modelForecast")} · MeteoSwiss via {openMeteo} · {licence} ·{" "}
      {t("wind.interpolated")}
    </>
  );
}
